import { FunctionComponent } from 'react'
import { Flex, getTheme, Text } from '@conexasaude/conexa-hero'
import { Icon } from '@conexasaude/iconography/icons'
import { useStyles } from './styles'

export const NoResults: FunctionComponent = () => {
  const styles = useStyles()
  const theme = getTheme()

  return (
    <Flex
      justify="center"
      gap="lg"
      direction="column"
      css={styles.mainContainer}
    >
      <Flex gap="sm" align="center" justify="center">
        <Icon name="user-error" color={theme.colors.neutral[200]} size={100} />

        <Flex direction="column" gap={theme.spacing.xxs}>
          <Text variant="headingMedium">Profissionais não encontrados</Text>
          <Text color={theme.colors.neutral[200]}>
            Ajuste os filtros da sua busca e tente novamente.
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default NoResults
